import { ObservabilityConnector, ITXObservabilityProvider, ObservabilityEnvironment, ObservabilityTenant, } from '@inditex/core-o11y-js';
import { getEnv } from '../EnvironmentTools';
import packageJson from '../../../package.json';
import appState from 'src/model/state';
import { isAndroid, isIOS } from '../utils';

let provider: ITXObservabilityProvider | null = null;
let connector: ObservabilityConnector | null = null;
let connectorToken = '';

function createObservabilityConnector(apiToken: string): ObservabilityConnector {
  provider = new ITXObservabilityProvider({
    apiToken,
  });

  return new ObservabilityConnector({
    config: {
      environment: getEnv()?.env as ObservabilityEnvironment || ObservabilityEnvironment.NONE,
      tenant: ObservabilityTenant.ZA,
      domain: 'webecom',
      projectKey: 'ZARSLLWEB',
      projectName: 'wsc-zararesell',
      appVersion: packageJson.version,
    },
    globalProperties: {
	    store: String(appState.get()?.store?.storeId ?? ''),
	    target: isIOS() ? 'ios' : isAndroid() ? 'android' : 'web',
	    o11ykollector: 'true'
   },
    providers: [provider],
  });
}

export const getObservabilityConnector = (): ObservabilityConnector | null => {
  const nextToken = getEnv()?.itxObservabilityApiToken || '';
  if (!nextToken) {
    return null;
  }

  const shouldRecreate = !connector || connectorToken !== nextToken;

  if (shouldRecreate) {
    connectorToken = nextToken;
    connector = createObservabilityConnector(nextToken);
  }

  return connector;
};

export const observabilityConnector: ObservabilityConnector = new Proxy({} as ObservabilityConnector, {
  get: (_target, property: keyof ObservabilityConnector) => {
    const connectorInstance = getObservabilityConnector();
    if (!connectorInstance) {
      return () => undefined;
    }
    const member = connectorInstance[property];

    if (typeof member === 'function') {
      return member.bind(connectorInstance);
    }

    return member;
  },
});
